import React from 'react';

import { Header } from 'components';
import { PrivateRoute } from 'utils';
import { ProfileForm } from '../../components';

export const Profile = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <ProfileForm />
    </>
  );
};
